import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactHero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[350px] md:h-[420px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://okayisu.com/common/img/site/iletisim-title-img.jpg"
          alt="Contact OKAYISU"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <div className="flex items-center gap-2 text-white/70 text-xs mb-4">
          <Link to="/" className="hover:text-amber-300 transition-colors duration-200 cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('contactPage.breadcrumbHome')}
          </Link>
          <i className="ri-arrow-right-s-line text-[10px]" />
          <span className="text-amber-400" style={{ fontFamily: "'Inter', sans-serif" }}>{t('contactPage.breadcrumb')}</span>
        </div>

        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-5">
          <span className="w-1 h-1 bg-amber-400 rounded-full" />
          <span className="text-amber-300 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('contactPage.hero.badge')}</span>
        </div>

        <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-5 max-w-2xl" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {t('contactPage.hero.title')}{' '}
          <span className="text-amber-400">{t('contactPage.hero.accent')}</span>
        </h1>

        <p className="text-white/70 text-sm md:text-base max-w-lg leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          {t('contactPage.hero.desc')}
        </p>
      </div>
    </section>
  );
}